import { useMutation } from 'react-query';
import { getOfficeHours, updateOfficeHours as updateOfficeHoursApi } from '@frontend/api-office-hours';
import { ScheduleAvailabilityByDayOfWeek } from '@frontend/api-schedule-availability';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useQuery } from '@frontend/react-query-helpers';
import { useAlert } from '@frontend/design-system';
import { queryKeys } from '../../query-keys';

export const useGetUpdateOfficeHoursMethodV2 = (locationId: string) => {
  const alert = useAlert();
  const { t } = useTranslation('schedule');

  //#region V2 Code

  const officeHoursV2 = useQuery({
    queryKey: queryKeys.officeClosedTimes(locationId),
    queryFn: () => getOfficeHours(locationId),
    retry: 1,
    enabled: !!locationId,
    onSettled: () => SchedulerV3.trackScheduleAPIVersionChange('v2', { endpoint: 'getOfficeHours' }),
  });

  const { mutate: updateOfficeHours, isLoading: isUpdatingOfficeHours } = useMutation({
    mutationFn: ({
      locationId: locId,
      schedule,
    }: {
      locationId: string;
      schedule: ScheduleAvailabilityByDayOfWeek;
    }) => {
      return updateOfficeHoursApi(locId, schedule);
    },
    onSuccess: () => {
      alert.success(t('Successfully updated schedule'));
      officeHoursV2.refetch();
    },
    onError: () => {
      alert.error(t('Failed to update schedule'));
    },
  });

  //#endregion

  const handleSave = (updatedScheduleAvailability: ScheduleAvailabilityByDayOfWeek) => {
    if (!updatedScheduleAvailability) return;

    updateOfficeHours({ locationId, schedule: updatedScheduleAvailability });
  };

  return {
    onSave: handleSave,
    isSaving: isUpdatingOfficeHours,
    isFetching: officeHoursV2.isFetching,
    officeHoursData: officeHoursV2.data,
    hasOfficeHoursFetchError: officeHoursV2.isError,
  };
};
